export default __webpack_public_path__ + "static/media/YAS0030.34I-27579_-16552_0.47474817.jpg";